<template>

  <div class="mb35 p20 brdr-1 brdr-cl-primary bg-cl-white" style="border-radius: 30px;">
    <!-- My complaints header -->

    <div class="row mb15">
      <div class="col-xs-12 col-sm-6">
        <h3 class="m0 mb5">
          {{ $t('My complaints') }}
        </h3>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div style="text-align: right;">
          <button-full :categoryProps="categoryProps" @click.native="createComplaint">
            {{ $t('Create complaint') }}
          </button-full>
        </div>
        <create-complaint />
        <complaint-created />
      </div>
    </div>

  
    <div class="row">
      <div class="col-xs-12" v-show="!isComplaintsListEmpty">
        <table class="brdr-1 brdr-cl-bg-secondary">
          <thead>
            <tr>                
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('RMA number') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('RMA type') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Status') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Create date') }}
              </th>
              <th class="p20 sans-serif lh20">
                &nbsp;
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="brdr-top-1 brdr-cl-bg-secondary" v-for="complaint in complaints" :key="complaint.id">
              <td class="fs-medium lh25 hide-on-xs">
                {{ complaint.rma_number ? complaint.rma_number : complaint.id }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
                {{ getRMAType(complaint.rma_type) }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
                {{ complaint.main_status }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
                {{ complaint.created | date('DD/MM/YYYY HH:mm', storeView) }}
              </td>
              <td class="fs-medium lh25">
                <span class="relative dropdown">
                  <i class="material-icons cl-secondary pointer">more_horiz</i>
                  <div class="dropdown-content bg-cl-primary align-left sans-serif lh20 weight-400 fs-medium-small py5">
                    <router-link class="no-underline block py10 px15" :to="localizedRoute(`/my-account/complaints/${complaint.id}`)">
                      {{ $t('View complaint details') }}
                    </router-link>                   
                  </div>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 h4" v-show="isComplaintsListEmpty">
        <p>{{ $t('No complaints yet') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import CreateComplaint from 'theme/components/core/blocks/MyAccount/CreateComplaint.vue'
import ComplaintCreated from 'theme/components/core/blocks/MyAccount/ComplaintCreated.vue'
import UserComplaints from '@vue-storefront/core/modules/user/components/UserComplaints'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import config from 'config'

export default {
  mixins: [UserComplaints],
  props: {
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    }
  },
  components: {
    ButtonFull,
    CreateComplaint,
    CmsBlockChunk,
    ComplaintCreated
  },
  data () {
    return {
      showConfirmation: false,
      config
    }
  },
  beforeMount () {
    this.$bus.$on('complaint-created', (rma) => this.complaintCreated(rma))
    this.$store.dispatch('user/getComplaints', { refresh: true, useCache: false })
  },
  computed: {
    storeView () {
      return currentStoreView()
    }
  },
  methods: {
    createComplaint () { 
      this.$bus.$emit('modal-show', 'modal-create-complaint')
    },
    complaintCreated (rma) {
      this.$bus.$emit('modal-show', 'modal-complaint-created');
    },
    getRMAType (type) {
      if (type == 'RMA_KlientD2D') {
        return 'Door To Door'
      } else if (type == 'RMA_Zwrot') {
        return 'Zwrot'
      } else if (type == 'service') {
        return 'Dom i biuro'
      } else {
        return type
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(secondary, $colors-background);

table {
  border-collapse: collapse;
  width: 100%;

  th, td {
    text-align: left;
    padding: 20px;

    @media (max-width: 1199px) {
      padding: 10px;
    }

    @media (max-width: 767px) {
      text-align: center;
    }

    &.hide-on-xs {

      @media (max-width: 767px) {
        display: none;
      }

    }

  }

  i {
    vertical-align: middle;
  }

}

.dropdown {
  display: block;
  margin: -20px;
  padding: 20px;

  @media (max-width: 1199px) {
    margin: -10px;
    padding: 10px;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    top: 100%;
    width: 160px;
    z-index: 1;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }

  a {
    opacity: .6;

    &:hover,
    &:focus {
      background-color: $color-icon-hover;
      opacity: 1;
    }

  }

  &:hover .dropdown-content {
    display: block;
  }

}

</style>
